import React, { useState } from "react";
import {
  Grid,
  Button,
  MenuItem,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ImportBillSelectingPopup from "./ImportBillSelectingPopup";
import { getImportBillById } from "../services/Import";

const paymentTypes = [
  { value: "CASH", label: "Cash" },
  { value: "CHEQUE", label: "Cheque" },
  { value: "BILL", label: "Recover Import Bill" },
  { value: "RECEIPT", label: "Receipt" },
];

function PaymentOptions({
  paymentTypes,
  paymentMethods,
  setPaymentMethods,
  billType,
}) {
  const [openImportBillTable, setOpenImportBillTable] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedBills, setSelectedBills] = useState([]);
  const [importBill, setImportBill] = useState(null);
  const [indexForBill, setIndexForBill] = useState(null);

  const addPaymentMethod = () => {
    setPaymentMethods([...paymentMethods, { type: "", amount: "" }]);
  };

  const updatePaymentMethod = (index, field, value) => {
    console.log("index", index);
    console.log("field", field);
    console.log("value", value);
    const updatedPayments = [...paymentMethods];
    updatedPayments[index][field] = value;
    setPaymentMethods(updatedPayments);
  };

  const removePaymentMethod = (index) => {
    setPaymentMethods(paymentMethods.filter((_, i) => i !== index));
  };

  const handleOpenImportBillTable = async (index) => {
    setIndexForBill(index);
    setOpenImportBillTable(true);
  };

  const handleCloseTable = async () => {
    setOpenImportBillTable(false);
    console.log("selectedBills", selectedBills);
    if (selectedBills.length > 0) {
      try {
        const result = await getImportBillById(selectedBills[0]);
        if (result) {
          setImportBill(result);
          //set payment details
          console.log("index for bill", indexForBill);
          updatePaymentMethod(indexForBill, "amount", parseFloat(result.total));
          updatePaymentMethod(indexForBill, "recoverBillNumber", result.billNo);
          updatePaymentMethod(indexForBill, "returnBillId", result.bill_id);
          console.log("importBill", result);
        } else {
        }
      } catch (error) {
        console.error("Error fetching bill data:", error);
      } finally {
      }
    }
  };

  return (
    <Grid>
      <Grid item xs={12} style={{ paddingBottom: "10px" }}>
        <Typography variant="h7">Payment Methods</Typography>
      </Grid>
      {paymentMethods.map((payment, index) => (
        <Grid
          container
          spacing={2}
          key={index}
          alignItems="center"
          style={{ paddingBottom: "10px" }}
        >
          <Grid item xs={2}>
            <TextField
              select
              fullWidth
              size="small"
              label="Payment Type"
              value={payment.type}
              onChange={(e) =>
                updatePaymentMethod(index, "type", e.target.value)
              }
            >
              {paymentTypes.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {!payment.recoverBillNumber ||
          (payment.recoverBillNumber && payment.recoverBillNumber != "") ? (
            <Grid item xs={2}>
              <TextField
                fullWidth
                size="small"
                label="Amount"
                type="number"
                value={payment.amount}
                onChange={(e) => {
                  updatePaymentMethod(index, "amount", e.target.value);
                }}
                onWheel={(e) => e.target.blur()}
              />
            </Grid>
          ) : null}

          {payment.type === "CHEQUE" && (
            <>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Bank Name"
                  value={payment.bank || ""}
                  onChange={(e) =>
                    updatePaymentMethod(index, "bank", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Cheque Number"
                  value={payment.chequeNumber || ""}
                  onChange={(e) =>
                    updatePaymentMethod(index, "chequeNumber", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      size="small"
                      label="Return Date"
                      value={payment.returnDateInput}
                      onChange={(date) => {
                        console.log("date", date);
                        setSelectedDate(date);
                        const jsDate = date ? date.toDate() : null;
                        updatePaymentMethod(index, "returnDate", jsDate);
                        updatePaymentMethod(index, "returnDateInput", date);
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </>
          )}

          {payment.type === "BILL" &&
          (billType == "RETAIL" || billType == "SALE") ? (
            <>
              <Grid item xs={3}>
                {payment.recoverBillNumber &&
                payment.recoverBillNumber != "" ? (
                  <TextField
                    fullWidth
                    disabled={true}
                    size="small"
                    label="Recover Import Bill Number"
                    value={payment.recoverBillNumber || ""}
                  />
                ) : (
                  <Button
                    onClick={() => handleOpenImportBillTable(index)}
                    variant="outlined"
                  >
                    Select Bill
                  </Button>
                )}
              </Grid>
            </>
          ) : null}

          {payment.type === "RECEIPT" && billType == "RETAIL" && (
            <>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Receipt Number"
                  value={payment.receiptNumber || ""}
                  onChange={(e) =>
                    updatePaymentMethod(index, "receiptNumber", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Shop Name"
                  value={payment.shopName || ""}
                  onChange={(e) =>
                    updatePaymentMethod(index, "shopName", e.target.value)
                  }
                />
              </Grid>
            </>
          )}

          <Grid item xs={1}>
            <IconButton
              color="error"
              onClick={() => removePaymentMethod(index)}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button variant="outlined" onClick={addPaymentMethod}>
          Add Payment Method
        </Button>
      </Grid>
      <Grid>
        {openImportBillTable ? (
          <ImportBillSelectingPopup
            setOpenTable={setOpenImportBillTable}
            openTable={openImportBillTable}
            handleCloseTable={handleCloseTable}
            setSelectedItems={setSelectedBills}
            selectedItems={selectedBills}
            isOneChoise={true}
            skipList={selectedBills}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

export default PaymentOptions;
